import { useState, MouseEvent, useEffect } from "react";
import { FilterBarType } from "../FilterBar";

import { ReactComponent as UsersIcon } from '../../../assets/Icons/adornments/User.svg';
import { ReactComponent as CheckIcon } from '../../../assets/Icons/adornments/Check.svg';

import FilterBarBtn from "./FilterBarBtn";
import { ClickAwayListener, Grow, Paper, Popper } from "@mui/material";
import { Dayjs } from "dayjs";
import FilterSearchBar from "./FilterSearchBar";
import { useTheme } from '@mui/material/styles';


export default function Users({
    filter,
    setFilterValue,
    anchorEl,
    handleOpen,
    handleClose,
}: {
    filter: {
        filters: FilterBarType[],
        groupKey?: string,
        value: string | string[] | { [key: string]: Dayjs | null } | null,
    },
    setFilterValue: (filters: FilterBarType[], value: string | string[] | { [key: string]: Dayjs | null } | null) => void,
    anchorEl: null | HTMLElement,
    handleOpen: (event: MouseEvent<HTMLButtonElement>) => void,
    handleClose: () => void,
}) {
    const [ selectedUser, setSelectedUser ] = useState<string | null>(null);
    const [ filteredOptions, setFilteredOptions ] = useState<string[]>([]);


    useEffect(() => {
        if (filter.value) {
            setSelectedUser(filter.value as string);
        } else {
            setSelectedUser(null);
        }
    }, [filter.value]);

    useEffect(() => {
        if (filter.filters[0].options) {
            setFilteredOptions(filter.filters[0].options);
        }
    }, [filter.filters]);

    const searchFn = (searchQuery: string) => {
        if (filter.filters[0].options) {
            const options = filter.filters[0].options;
            setFilteredOptions(options.filter(opt => opt.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())));
        }
    };
        
    

    const handleUserSelection = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        setSelectedUser(e.currentTarget.value);
    }


    const undoUserSelection = () => {
        handleClose();
        const userVal = filter.value as string | null;
        setSelectedUser(userVal);
    }

    const resetUserSelection = () => {
        handleClose();
        setSelectedUser(null);
        setFilterValue(filter.filters, null);
    }

    const applyUserSelection = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        setFilterValue(filter.filters, selectedUser);
        handleClose();
    };

    const theme = useTheme();

    return (
        <>
            <FilterBarBtn 
                label={filter.filters[0].label}
                value={filter.value as string | null}
                icon={<UsersIcon />}
                isOpen={Boolean(anchorEl && anchorEl.id === filter.filters[0].param)}
                handleOpen={handleOpen}
                handleClose={handleClose}
                resetFn={resetUserSelection}
                id={filter.filters[0].param}
            />
            <Popper open={Boolean(anchorEl && anchorEl.id === filter.filters[0].param)} anchorEl={anchorEl} placement="bottom-start" sx={{ zIndex: 2000 }} transition>
                {({ TransitionProps }) => (
                <Grow {...TransitionProps} in={Boolean(anchorEl && anchorEl.id === filter.filters[0].param)} style={{ transformOrigin: '0 0 0' }}>
                <Paper
                    sx={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        marginTop: '8px',
                        boxShadow: theme.shadows[8],
                    }}
                >
                    <ClickAwayListener onClickAway={undoUserSelection}>
                        <div className="w-full flex flex-col justify-start items-stretch bg-white max-w-[350px]">
                            <div className="w-full flex flex-col justify-start items-stretch p-4 gap-3 border-b border-light-outline border-dashed">
                                <FilterSearchBar 
                                    label="Search Users"
                                    searchFn={searchFn}
                                />
                            </div>

                            <div className="max-h-[300px] overflow-y-auto">
                                <div className="flex flex-col justify-start items-stretch py-2">
                                    {filteredOptions.length > 0 && filteredOptions.map((option,i) => (
                                        <button key={i} onClick={handleUserSelection} value={option} className={`${selectedUser && selectedUser.includes(option) ? 'bg-secondary text-primary hover:bg-opacity-1 justify-between' : 'bg-none text-default hover:bg-opacity-[0.5] justify-start'} hover:cursor-pointer hover:text-primary hover:bg-secondary text-left font-medium flex items-center gap-3 px-4 py-3 w-full`}>
                                            <p className="text-nowrap text-[14px]">{option}</p>
                                            {selectedUser && selectedUser.includes(option) && (
                                                <div className="w-[16px]"><CheckIcon /></div>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="flex justify-end items-center gap-2 p-4 border-t border-light-outline">
                                <button onClick={resetUserSelection} className="px-4 py-3 text-primary font-medium text-[12px]">Reset</button>
                                <button onClick={applyUserSelection} className="px-4 py-3 text-white font-medium bg-primary rounded-lg text-[12px]">Apply</button>
                            </div>
                        </div>
                    </ClickAwayListener>
                </Paper>
                </Grow>
                )}
            </Popper>
        </>
    )
}